



























































import Vue from "vue";
import iwSectionWithIcon from "@/encoding/components/layout/SectionWithIcon.vue";
import iwLandArea from "@/encoding/pages/questions/exterior/LandArea.vue";
import iwHasGarden from "@/encoding/pages/questions/exterior/HasGarden.vue";
import iwHasTerrace from "@/encoding/pages/questions/exterior/HasTerrace.vue";
import iwStateLand from "@/encoding/pages/questions/exterior/StateLand.vue";
import iwPropertySetting from "@/encoding/pages/questions/exterior/PropertySetting.vue";
import iwHasSwimmingPool from "@/encoding/pages/questions/exterior/HasSwimmingPool.vue";
import iwHasSeaView from "@/encoding/pages/questions/exterior/HasSeaView.vue";
import iwNextPreviousButton from "@/encoding/components/NextPreviousButton.vue";
import { updateClassified, validationClassified } from "@/shared/scripts/ValidateData";
import { mapActions, mapState } from "vuex";
import { pushPageViewEvent } from "@/shared/store/modules/gtm/datalayer";

export default Vue.extend({
    components: {
        iwSectionWithIcon: iwSectionWithIcon,
        iwHasGarden: iwHasGarden,
        iwHasTerrace: iwHasTerrace,
        iwLandArea: iwLandArea,
        iwHasSeaView: iwHasSeaView,
        iwPropertySetting: iwPropertySetting,
        iwHasSwimmingPool: iwHasSwimmingPool,
        iwStateLand: iwStateLand,
        iwNextPreviousButton: iwNextPreviousButton
    },

    data: function() {
        return {
            isButtonDisabled: false as boolean
        };
    },

    computed: {
        ...mapState("FormModule", ["isEditionMode"]),
        isDisplayedLand: function (): boolean {
            return ["HOUSE", "OFFICE", "INDUSTRY", "COMMERCIAL", "LAND", "OTHER"].indexOf(this.getPropertyType()) !== -1;
        },
        isDisplayedGarden: function(): boolean {
            return ["HOUSE", "OFFICE", "COMMERCIAL", "APARTMENT", "OTHER", "HOMES_TO_BUILD"].indexOf(this.getPropertyType()) !== -1;
        },
        isDisplayedEnvironment: function(): boolean {
            return ["HOUSE", "OFFICE", "INDUSTRY", "COMMERCIAL","APARTMENT", "LAND", "OTHER"].indexOf(this.getPropertyType()) !== -1;
        }
    },

    mounted: function() {
        pushPageViewEvent("classified_deposit_step7_exterior_info");
    },

    methods: {
        ...mapActions({
            goToPreviousStep: "StepsWizard/previous",
            goToNextStep: "StepsWizard/next"
        }),
        clickNext: function(){
            this.isButtonDisabled = true;
            if (this.isEditionMode){
                validationClassified((success:boolean) => {
                    Vue.nextTick(() => {
                        const inputsError = document.getElementsByClassName("input--error") as HTMLCollectionOf<HTMLElement>;
                        if (inputsError.length > 0) {
                            inputsError[0].focus();
                            window.scrollTo(0, 0);
                        }
                        this.isButtonDisabled = false;
                        this.goToNextStep();
                    });
                });
            } else {
                this.isButtonDisabled = true;
                updateClassified((success:boolean) => {
                    Vue.nextTick(() => {
                        const inputsError = document.getElementsByClassName("input--error") as HTMLCollectionOf<HTMLElement>;
                        if (inputsError.length > 0) {
                            inputsError[0].focus();
                            window.scrollTo(0, 0);
                        }
                        this.isButtonDisabled = false;
                        this.goToNextStep();
                    });
                });
            }
        },
        clickPrevious: function(){

            this.goToPreviousStep();
        }
    }
});

